import { useEffect, useRef } from 'react'

const LEVELS = [
  { label: 'Audio Fundamentals', sub: 'sound, waveforms, pressure', color: '#1ec8ff' },
  { label: 'Digital Signal Processing', sub: 'sampling, Nyquist, filtering', color: '#36b6ff' },
  { label: 'Fourier / STFT', sub: 'frequency decomposition', color: '#5a9bff' },
  { label: 'Spectrograms', sub: 'mel scale, time-frequency', color: '#7b82ff' },
  { label: 'Audio in Python', sub: 'librosa, torchaudio', color: '#9a6dff' },
  { label: 'Speech Recognition', sub: 'Whisper, CTC, attention', color: '#b45cff' },
  { label: 'Deep Learning for Audio', sub: 'CNNs, RNNs, encoders', color: '#d24bf0' },
  { label: 'Transformers', sub: 'self-attention, decoders', color: '#ef4ac0' },
  { label: 'Voice Cloning & TTS', sub: 'speaker vectors, codecs', color: '#ff4f96' },
  { label: 'Realtime Voice Agents', sub: 'low-latency STT→LLM→TTS', color: '#ff5a72' },
]

const NODE_X = 30
const NODE_Y0 = 40
const NODE_GAP = 62
const NODES = LEVELS.map((l, i) => ({ ...l, n: i + 1, x: NODE_X, y: NODE_Y0 + i * NODE_GAP }))

// First principles → state of the art, as a single climbing path — a pulse
// travels 1 → 10 to show the order, same idea as the desktop two-column path.
export function Scene13Roadmap2D() {
  const dotRef = useRef()
  const raf = useRef(0)

  useEffect(() => {
    let start = performance.now()
    const loop = (now) => {
      const t = Math.max(0, (now - start) / 1000)
      const prog = (t * 0.06) % 1
      const f = prog * (NODES.length - 1)
      const i = Math.min(NODES.length - 2, Math.floor(f))
      const local = f - i
      const y = NODES[i].y + (NODES[i + 1].y - NODES[i].y) * local
      if (dotRef.current) {
        dotRef.current.setAttribute('cx', NODE_X)
        dotRef.current.setAttribute('cy', y.toFixed(1))
      }
      raf.current = requestAnimationFrame(loop)
    }
    raf.current = requestAnimationFrame(loop)
    return () => cancelAnimationFrame(raf.current)
  }, [])

  return (
    <svg viewBox={`0 0 320 ${NODE_Y0 + NODES.length * NODE_GAP}`} style={{ width: '100%', maxWidth: 340, height: 'auto', display: 'block', margin: '0 auto' }}>
      {NODES.slice(0, -1).map((n, i) => (
        <line key={i} x1={n.x} y1={n.y} x2={NODES[i + 1].x} y2={NODES[i + 1].y} stroke="#33506b" strokeWidth="1.5" opacity="0.4" />
      ))}
      {NODES.map((n) => (
        <g key={n.n}>
          <circle cx={n.x} cy={n.y} r="15" fill="none" stroke={n.color} strokeWidth="2" opacity="0.4" />
          <circle cx={n.x} cy={n.y} r="13" fill={n.color} />
          <text x={n.x} y={n.y} fill="#02060d" fontSize="12" fontFamily="system-ui, sans-serif" textAnchor="middle" dominantBaseline="middle" fontWeight="700">{n.n}</text>
          <text x={n.x + 26} y={n.y - 6} fill={n.color} fontSize="12" fontFamily="system-ui, sans-serif">{n.label}</text>
          <text x={n.x + 26} y={n.y + 12} fill="#7b93a6" fontSize="9" fontFamily="system-ui, sans-serif">{n.sub}</text>
        </g>
      ))}
      <circle ref={dotRef} r="5" fill="#ffffff" />
    </svg>
  )
}
